<style lang="less">
@import "./index.less";
.login-footer {
  position: fixed;
  left: 0;
  width: 100%;
  text-align: center;
  bottom: 20px;
  a {
    color: #fff!important;
  }
}
</style>

<template>
  <div class="login-container">

    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">

      <div class="title-container">
        <h3 class="title">登录到{{appTitle}}</h3>
      </div>

      <el-form-item prop="email">
        <span class="icon-container">
          <icon name="perm_identity" />
        </span>
        <el-input v-model="loginForm.email" placeholder="请输入邮箱" name="email" type="text" auto-complete="on" />
      </el-form-item>

      <el-form-item prop="password">
        <span class="icon-container">
          <icon name="lock" />
        </span>
        <el-input :type="passwordType" v-model="loginForm.password" placeholder="请输入密码" name="password" auto-complete="on" @keyup.enter.native="login" />
        <span class="show-pwd" @click="showPwd">
          <icon :name="passwordType == 'password' ? 'visibility' : 'visibility_off'" />
        </span>
      </el-form-item>

      <el-button :loading="loading" type="primary" class="green-btn" style="width:100%;margin-bottom:30px;" @click.native.prevent="login">登录</el-button>

    </el-form>

    <div class="login-footer">
      <a href="https://beian.miit.gov.cn/">沪ICP备 14020594号-5</a>
    </div>

  </div>
</template>

<script>

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: this.$formHelper.rules.emailRequired,
        password: this.$formHelper.rules.passwordRequired
      },
      passwordType: 'password',
      loading: false,
      redirectToName: undefined
    }
  },
  computed: {
    appTitle() {
      return this.$config.title
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirectToName = route.query && route.query.redirectToName
      },
      immediate: true
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    async login() {
      await this.$formHelper.promisedValidate(this.$refs.loginForm)
      try {
        this.loading = true
        await this.$store.dispatch('auth/login', this.loginForm)
        console.log('this.redirectToName ', this.redirectToName );
        this.$router.push({ name: this.redirectToName || 'dashboard' })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
